import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { OvsComponent, Core, LabelNames, ApplicationConfiguration, FooterLink } from '../shared/core/ovs.core';
import { BootstrapHelperService } from '../instrumentation/bootstrap-helper.service';

@Component({
  selector: 'main-footer',
  templateUrl: './main-footer.component.html',
  styleUrls: ['./main-footer.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class MainFooterComponent extends OvsComponent
{
    public copyright: string;
    public sot: string;
    public partnerName: string;
    public phoneNumber: string;
    public footers: FooterLink[];
    public count: number;
    constructor(core: Core, private btsHelperService:BootstrapHelperService)
    {
        super();
        this.subscribe(core.configuration, c => this.OnConfigurationChanged(c)); 
        this.btsHelperService.MainFooterLoadCount=this.btsHelperService.MainFooterLoadCount+1;
        this.count = this.btsHelperService.MainFooterLoadCount;
    }

    public initialize(): void
    {
    }

    private OnConfigurationChanged(config: ApplicationConfiguration): void
    {
        this.copyright = config.Labels ? config.Labels.first(l => l.Name == LabelNames.Copyright).DisplayText : "---";
        this.sot = config.Labels ? config.Labels.first(l => l.Name == LabelNames.Sot).DisplayText : "---";
        this.partnerName = config.Partner ? config.Partner.LongName : "---";
        this.phoneNumber = config.Partner ? config.Partner.PhoneNumber : "---";
        this.footers = config.FooterLinks; 
    }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/Ovs.Resort.UI.Web/src/app/footer/main-footer.component.ts